import React, { useState, useEffect } from 'react';
import { GET_ONE, UPDATE, Responsive, Title, WithPermissions, showNotification } from 'react-admin';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import dataProvider from '../../dataProvider';
import Locale from './Locale';
import PrivilegedAccount from './PrivilegedAccount';
import Report from './Report';
import Version from './VersionInfo';
import ContractInfo from './ContractInfo';
import { isPermissiveAsAccountManager, isManager } from '../../const/Role';
import AppSettingConfig from './AppSettingConfig';
import CalendarServiceConfig from './CalendarServiceConfig';

const styles = {
  flex: { display: 'flex' },
  flexColumn: { display: 'flex', flexDirection: 'column' },
  leftCol: { flex: 1, marginRight: '1em' },
  rightCol: { flex: 1, marginLeft: '1em' },
  singleCol: { marginTop: '2em', marginBottom: '2em' },
};

const Config = ({ permissions, showNotification }) => {
  const [config, setConfig] = useState();

  const getConfig = async () => {
    await dataProvider(GET_ONE, 'tenants', { id: 'me' })
      .then(response => response.data)
      .then(data => {
        setConfig(data);
      })
      .catch(e => {
        showNotification('ra.message.error', 'warning');
      });
  };

  /**
   * テナント設定を更新する
   * needSyncをtrueに設定した場合はサーバーと設定値を同期させる
   * @param {Object} newConfig
   * @param {boolean} needSync
   */
  const updateConfig = async (newConfig, needSync) => {
    const prevConfig = { ...config };
    // 先に状態を更新する
    setConfig(newConfig);

    if (needSync) {
      await dataProvider(UPDATE, 'tenants', {
        id: 'me',
        data: { isEnableAppAuth: newConfig.isEnableAppAuth },
      }).catch(e => {
        showNotification('ra.message.error', 'warning');
        setConfig(prevConfig);
      });
    }
  };

  useEffect(() => {
    // 一般ユーザーは設定を取得しない
    if (permissions && isManager(permissions)) {
      getConfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [permissions]);

  const renderComponents = () => {
    return (
      permissions && (
        <div style={styles.flexColumn}>
          <div style={styles.singleCol}>
            {isManager(permissions) && config && (
              <PrivilegedAccount
                permissions={permissions}
                config={config}
                getConfig={getConfig}
                updateConfig={updateConfig}
              />
            )}
            <br />
            {isManager(permissions) && config && (
              <AppSettingConfig
                permissions={permissions}
                config={config}
                getConfig={getConfig}
                updateConfig={updateConfig}
              />
            )}
            <br />
            {isManager(permissions) && config && (
              <CalendarServiceConfig
                permissions={permissions}
                config={config}
                getConfig={getConfig}
              />
            )}
            <br />
            {isPermissiveAsAccountManager(permissions) && <Locale />}
            <br />
            {isManager(permissions) && <Report />}
            <br />
            {isManager(permissions) && <ContractInfo />}
            <br />
            <Version />
          </div>
        </div>
      )
    );
  };

  return (
    <>
      <Title title={'config.title'} />
      <Responsive
        xsmall={renderComponents()}
        small={renderComponents()}
        medium={
          <div style={styles.flex}>
            <div style={styles.leftCol}>{renderComponents()}</div>
          </div>
        }
      />
    </>
  );
};

const ConfigWithPermissions = ({ location, showNotification }) => (
  <WithPermissions
    location={location}
    render={({ permissions }) => <Config permissions={permissions} showNotification={showNotification} />}
  />
);

const enhance = compose(connect(undefined, { showNotification }));
export default enhance(ConfigWithPermissions);
